import { defineMessages } from 'react-intl';

const messages = defineMessages({
  Date: 'Date',
  Registration: 'Registration',
  Relation: 'Relation',
  Distance: 'Distance',
  Assignment: 'Assignment',
  SelectAnAssignment: 'Select an assignment',
  What: 'What',
  SearchPriceListItem: 'Search pricelist item',
  NoPriceListItemsFound: 'No pricelist items found',
  Duration: 'Duration',
  DurationInDays: 'Duration in days',
  DurationInHours: 'Duration in hours',
  HalfDay: 'Half day',
  Morning: 'Morning',
  Afternoon: 'Afternoon',
  Days: 'Days',
  Hours: 'Hours',
  DefaultAssignment: 'Default assignment',
  Price: 'Price',
  Discount: 'Discount',
  Quantity: 'Quantity',
  VAT: 'VAT',
  SelectAVatPercentage: 'Select a VAT percentage',
  TotalExcl: 'Total excl.',
  Billable: 'Billable',
  Remark: 'Remark',
  InternalRemark: 'Internal remark',
  AddMinutes: 'Add {minutes} minutes',
  RoundToNearest5: 'Round to nearest 5',
  RoundToNearest10: 'Round to nearest 10',
  RoundToNearestQuarter: 'Round to nearest quarter',
  RoundToNearestX: 'Rount to nearest {minutes}',
  From: 'From',
  Until: 'Until',
  Registered: 'Registered',
  InForfait: 'In forfait',
  Time: 'Time',
  Cost: 'Cost',
  Task: 'Task',
  SelectASubtask: 'Select a subtask',
  SubTask: 'Sub task',
  RegistrationDurationPerRelation: '{minutes} minutes per relation will be registered.',
  RegistrationQuantityPerRelation: '{quantity}x {resource} per relation will be registered.',
  DurationPerRelationMinimum1MinuteWarning:
    'You need to register at least 1 minute per relation ({minutes} in total)',
  RegistrationOutsideWorkingHoursWarning:
    'Your working hours {startHour} - {endHour} will be used for these registrations.',
  PerRelationLowerCase: 'per relation',
  CreatePhoneCallTooltip:
    'Click here and use the textbox on the right to register a report of your phone call. This phone call will be added to the timeline of the relation.',
  CreateNoteTooltip:
    'Click here and use the textbox on the right to register a note. This note will be added to the timeline of the relation.',
  CreateMeetingReportTooltip:
    'Click here and use the textbox on the right to register a meeting report. This meeting report will be added to the timeline of the relation.',
  InvoiceRemark: 'Invoice remark',
  RelationLanguage: 'Relation language',
  RegistrationModified: 'Registration modified',
  CommunicationReportTitle: 'Title communication report',
  CommunicationReportDescription: 'Description communication report',
  TotalDuration: 'Total duration',
  RemainingOvertimeHours: 'Remaining overtime hours',
  RemainingOvertimeHoursAfterSave: 'Remaining overtime after save',
  FillWith: 'Fill with',
  RegTimeFromTo: 'From-to',
  ReferenceYear: 'Reference year',
  ResourceFixedPriceTooltip: 'Resource with fixed price',
  AddRegistration: 'Add registration',
  EditRegistration: 'Edit registration',
  AddAbsence: 'Add absence',
  EditAbsence: 'Edit absence',
  AddRecuperation: 'Add recuperation',
  EditRecuperation: 'Edit recuperation',
  OwnCompany: 'Own company',
  AbsenceBalance: 'Absence balance',
  BalanceAfter: 'Balance after',
  User: 'User',
  SystemUser: 'System user',
  AddTraining: 'Add training',
  EditTraining: 'Edit training',
  Training: 'Training',
  SelectTraining: 'Select training',
  TrainingComplete: 'Training complete',
  NoAssignedTrainings: 'No assigned trainings',
});

export default messages;
